import React from 'react'
import { useQuery } from 'react-query'
import { indexBy, pathOr, prop } from 'ramda'
import { IOptionsResp } from './options.type'

export const useProdLogicType = () => {
  const { data, isFetching, refetch } = useQuery<IOptionsResp[]>(['/options/prodLogicTypes'], {
    select: data => pathOr([], ['data'], data),
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnMount: false,
  })

  const byId = React.useMemo(() => indexBy(prop('id'), data || []), [data])

  return {
    data,
    isLoading: isFetching,
    refetch,
    byId,
  }
}
